export default __webpack_public_path__ + "static/media/37_mobile.90036f23.jpg";